import { render, staticRenderFns } from "./AbkSubEventsBox.vue?vue&type=template&id=1831a78a&scoped=true&"
import script from "./AbkSubEventsBox.vue?vue&type=script&lang=js&"
export * from "./AbkSubEventsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkSubEventsBox.vue?vue&type=style&index=0&id=1831a78a&scoped=true&lang=scss&"
import style1 from "./AbkSubEventsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831a78a",
  null
  
)

export default component.exports